import styled from "@styled";

export const StyledTitle = styled.h2`
    font-size: 34px;
    font-weight: 500;
    margin-block-end: 27px;
`;
